import React from 'react';
import styled from 'styled-components';
import { FaCar, FaPaintRoller, FaOilCan, FaBullseye, FaWrench, FaShieldAlt } from 'react-icons/fa';

const ServicesContainer = styled.section`
  padding: 80px 0;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ServicesH1 = styled.h1`
  font-size: 2.5rem;
  color: #4F4C4C;
  margin-bottom: 64px;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const ServicesWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  grid-gap: 30px;
  padding: 0 20px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

const ServiceCard = styled.div`
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;

const ServicesIcon = styled.div`
  font-size: 4rem;
  color: #c77408;
  margin-bottom: 20px;
`;

const ServicesH2 = styled.h2`
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: #4F4C4C;
`;

const ServicesP = styled.p`
  font-size: 1rem;
  text-align: center;
  color: #4F4C4C;
`;

const Services = () => {
  return (
    <ServicesContainer id="services">
      <ServicesH1>Nossos Serviços</ServicesH1>
      <ServicesWrapper>
        <ServiceCard>
          <ServicesIcon><FaWrench /></ServicesIcon>
          <ServicesH2>Mecânica Geral</ServicesH2>
          <ServicesP>Manutenção completa do motor, suspensão, freios e mais.</ServicesP>
        </ServiceCard>
        <ServiceCard>
          <ServicesIcon><FaPaintRoller /></ServicesIcon>
          <ServicesH2>Lanternagem e Pintura</ServicesH2>
          <ServicesP>Reparos em lataria e pintura com acabamento de primeira linha.</ServicesP>
        </ServiceCard>
        <ServiceCard>
          <ServicesIcon><FaOilCan /></ServicesIcon>
          <ServicesH2>Troca de Óleo e Filtros</ServicesH2>
          <ServicesP>Serviço rápido com os melhores produtos para seu motor.</ServicesP>
        </ServiceCard>
        <ServiceCard>
          <ServicesIcon><FaBullseye /></ServicesIcon>
          <ServicesH2>Alinhamento e Balanceamento</ServicesH2>
          <ServicesP>Tecnologia de ponta para garantir sua segurança e conforto ao dirigir.</ServicesP>
        </ServiceCard>
        <ServiceCard>
          <ServicesIcon><FaShieldAlt /></ServicesIcon>
          <ServicesH2>Revisão Completa</ServicesH2>
          <ServicesP>Check-up detalhado de todos os itens de segurança e performance.</ServicesP>
        </ServiceCard>
        <ServiceCard>
          <ServicesIcon><FaCar /></ServicesIcon>
          <ServicesH2>E Muito Mais</ServicesH2>
          <ServicesP>Consulte nossa equipe para diagnósticos e outros serviços especializados.</ServicesP>
        </ServiceCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;